export default __webpack_public_path__ + "static/FL_VTB_0924_paddleboard_28A0473_med_Web72DPI19220px-0b13f6d3709dc4f33ed2c64143d64e4e.jpg";